<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

  function addUser() {
    dispatch('addUserClick');
  }
</script>

<div class="grid grid-cols-1 gap-5 border border-surface-500 p-5 rounded-container-token">
  <div class="mb-5 text-lg font-bold text-primary-500">Users</div>
  <div class="grid grid-cols-3 bg-[#FAFAFC] p-5 rounded-container-token">
    <div></div>

    <div class="flex items-center justify-center">
      <button
        class="text-bold btn bg-[#D0D9E4] text-lg text-[#232F55] hover:bg-[#C0C9D4] focus:ring focus:ring-primary-500 focus:ring-offset-2 active:bg-[#B0B9C4]"
        on:click={addUser}
      >
        Add New User
      </button>
    </div>

    <div class="flex justify-end">
      <img src="/user/project-planning.svg" alt="" class="h-auto w-36" />
    </div>
  </div>
</div>
